import { decodeWpRenderedText, isRecord, unwrapResponseJson } from './wpApi'

export type DeckJsonV1 = {
  id: string
  title: string
  status?: string
  cardIds: string[]
  groups?: DeckGroupJsonV1[]
  props?: Record<string, unknown>
  allowAnonymous?: boolean
  updatedAt: string
  revision: number
}

export type DeckGroupJsonV1 = {
  id?: string
  title: string
  cardIds: string[]
}

export const normalizeDeckResponse = (json: unknown): DeckJsonV1 | null => {
  const unwrapped = unwrapResponseJson(json)
  if (!isRecord(unwrapped)) return null

  const version = (unwrapped as Record<string, unknown>).version
  const deck = (unwrapped as Record<string, unknown>).deck
  if (version !== 1 || !isRecord(deck)) return null

  const id = (deck as Record<string, unknown>).id
  const title = (deck as Record<string, unknown>).title
  const status = (deck as Record<string, unknown>).status
  const cardIds = (deck as Record<string, unknown>).cardIds
  const props = (deck as Record<string, unknown>).props
  const groups = (deck as Record<string, unknown>).groups
  const allowAnonymous = (deck as Record<string, unknown>).allowAnonymous
  const updatedAt = (deck as Record<string, unknown>).updatedAt
  const revision = (deck as Record<string, unknown>).revision

  if (typeof id !== 'string') return null
  if (typeof title !== 'string') return null
  if (!Array.isArray(cardIds) || !cardIds.every((x) => typeof x === 'string')) return null
  if (typeof updatedAt !== 'string') return null
  if (typeof revision !== 'number') return null

  let normalizedGroups: DeckGroupJsonV1[] | undefined
  if (Array.isArray(groups)) {
    const parsed: DeckGroupJsonV1[] = []
    for (const item of groups) {
      if (!isRecord(item)) continue

      const groupId = (item as Record<string, unknown>).id
      const groupTitle = (item as Record<string, unknown>).title
      const groupCardIds = (item as Record<string, unknown>).cardIds

      if (typeof groupTitle !== 'string') continue
      if (!Array.isArray(groupCardIds) || !groupCardIds.every((x) => typeof x === 'string')) {
        continue
      }

      if (typeof groupId !== 'undefined' && typeof groupId !== 'string') continue

      parsed.push({
        id: typeof groupId === 'string' ? groupId : undefined,
        title: groupTitle,
        cardIds: groupCardIds as string[],
      })
    }

    normalizedGroups = parsed
  }

  return {
    id,
    title: decodeWpRenderedText(title),
    status: typeof status === 'string' ? status : undefined,
    cardIds: cardIds as string[],
    groups: normalizedGroups,
    props:
      typeof props === 'object' && props && !Array.isArray(props)
        ? (props as Record<string, unknown>)
        : undefined,
    allowAnonymous: typeof allowAnonymous === 'boolean' ? allowAnonymous : false,
    updatedAt,
    revision,
  }
}
